import { FC } from "react";

const Policy: FC<{}> = () => {
  return (
    <section>
      <div className="row">
        <h2>POLITYKA PRYWATNOŚCI</h2>
        <p>
          1. Administrator Danych
          <br />
          Administratorem danych osobowych Użytkowników serwisu Lokalnytrener.pl
          jest firma JUSTKICKS - Filip Juskowiak, z siedzibą pod adresem
          os.Oświecenia 98/57 61-211 Poznań, NIP 7822906919, REGON 521109593. W
          razie pytań dotyczących przetwarzania danych osobowych można
          skontaktować się pod adresem e-mail: support@lokalnytrener.pl
        </p>
        <p>
          2. Zakres i Cel Przetwarzania Danych
          <br />
          Serwis Lokalnytrener.pl zbiera następujące dane osobowe:
          <br />
          - Imię i nazwisko,
          <br />
          - Adres e-mail,
          <br />
          - Numer telefonu,
          <br />
          - Dane dotyczące lokalizacji,
          <br />
          - Dane dotyczące płatności,
          <br />
          - Inne dane podane dobrowolnie przez Użytkownika w ramach korzystania
          z serwisu.
          <br />
          Dane te są przetwarzane w następujących celach:
          <br />
          - Rejestracja konta i zarządzanie kontem użytkownika,
          <br />
          - Realizacja usług świadczonych przez serwis,
          <br />
          - Obsługa płatności,
          <br />
          - Komunikacja z użytkownikami,
          <br />
          - Marketing i personalizacja ofert,
          <br />- Analiza statystyczna i poprawa funkcjonalności serwisu.
        </p>
        <p>
          3. Podstawa Prawna Przetwarzania
          <br />
          Dane przetwarzane są zgodnie z:
          <br />
          - Art. 6 ust. 1 lit. a RODO - na podstawie zgody użytkownika,
          <br />
          - Art. 6 ust. 1 lit. b RODO - w celu realizacji umowy,
          <br />
          - Art. 6 ust. 1 lit. c RODO - w celu wypełnienia obowiązków prawnych
          ciążących na Administratorze,
          <br />- Art. 6 ust. 1 lit. f RODO - w celu realizacji prawnie
          uzasadnionych interesów Administratora.
        </p>
        <p>
          4. Prawa Użytkowników
          <br />
          Każdy Użytkownik ma prawo do:
          <br />
          - Dostępu do swoich danych,
          <br />
          - Sprostowania błędnych danych,
          <br />
          - Usunięcia danych („prawo do bycia zapomnianym”),
          <br />
          - Ograniczenia przetwarzania,
          <br />
          - Przenoszenia danych,
          <br />
          - Wniesienia sprzeciwu wobec przetwarzania danych,
          <br />- Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.
        </p>
        <p>
          5. Udostępnianie Danych Podmiotom Trzecim
          <br />
          Dane osobowe mogą być udostępniane:
          <br />
          - Partnerom technologicznym, zapewniającym hosting i usługi IT,
          <br />
          - Operatorom płatności,
          <br />
          - Firmom marketingowym i analitycznym,
          <br />- Organom administracji publicznej, jeżeli wymaga tego prawo.
        </p>
        <p>
          6. Pliki Cookies
          <br />
          Serwis wykorzystuje pliki cookies w celach statystycznych,
          marketingowych oraz zapewnienia prawidłowego działania strony.
          Użytkownik może zarządzać ustawieniami cookies poprzez ustawienia
          swojej przeglądarki.
        </p>
      </div>
    </section>
  );
};

export default Policy;
